export const COMPANY_IDENTITY = Object.freeze({
  legalName: 'MICROTEN Canarias, Sistemas y Tratamiento de Datos, S.L.',
  taxId: 'B38907572',
  fiscalAddress: 'Ctra. Gral. del Norte, 249',
  postalCode: '38350',
  locality: 'Tacoronte',
  province: 'Santa Cruz de Tenerife',
  phone: '922 578864',
  email: 'info@microten.es',
  website: 'www.microten.es',
  logo: Object.freeze({
    master: '/branding/MICROTEN-2026-MASTER.svg',
    documents: '/branding/MICROTEN-2026-principal-color.svg',
  }),
});

export default COMPANY_IDENTITY;
